import { App } from "vue";
import { initGlobalStore, GlobalStoreInterface } from '@/utils/global-store'
import { initNavigation, NavigationInterface } from "@/utils/navigation";

declare module '@vue/runtime-core' {
    interface ComponentCustomProperties {
        $store: GlobalStoreInterface,
        $navigation: NavigationInterface,
    }
}

export function initCustomApp(app: App) : App {
    initGlobalStore(app);
    initNavigation(app);
    return app;
}
